import { render, staticRenderFns } from "./ContentTestiMobile.vue?vue&type=template&id=1efd955a"
import script from "./ContentTestiMobile.vue?vue&type=script&lang=js"
export * from "./ContentTestiMobile.vue?vue&type=script&lang=js"
import style0 from "./ContentTestiMobile.vue?vue&type=style&index=0&id=1efd955a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports